// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2etFI","overflowing":"ReadFullNote_overflowing__2dluL"};